export const BASE_URL = "https://app.coachitright.com:8801";
export const IMG_URL = "https://app.coachitright.com:8801/";

const ADMIN_PREFIX = BASE_URL + "/admin";

export const ADMIN_LOGIN_API = ADMIN_PREFIX + "/admin_login";
export const ADMIN_LOGOUT_API = BASE_URL + "/auth/logout";
export const REFRESH_TOKEN_API = BASE_URL + "/auth/refresh_token";

export const DASHBOARD_API = ADMIN_PREFIX + "/dashboard_count";
export const USER_LIST_API = ADMIN_PREFIX + "/user_list";
export const USER_DETAIL_API = ADMIN_PREFIX + "/user_detail";
export const CHANGE_PASSWORD_API = ADMIN_PREFIX + "/change_password";
export const BLOCK_UNBLOCK_USER_API = ADMIN_PREFIX + "/block_unblock";

export const ADD_LANGUAGE_API = ADMIN_PREFIX + "/add_language";
export const GET_LANGUAGE_API = ADMIN_PREFIX + "/language_list";
export const UPDATE_LANGUAGE_API = ADMIN_PREFIX + "/edit_language";
export const DELETE_LANGUAGE_API = ADMIN_PREFIX + "/delete_language";

export const ADD_SPECIALITIES_API = ADMIN_PREFIX + "/add_specialities";
export const GET_SPECIALITIES_API = ADMIN_PREFIX + "/specialities_list";
export const UPDATE_SPECIALITIES_API = ADMIN_PREFIX + "/edit_specialities";
export const DELETE_SPECIALITIES_API = ADMIN_PREFIX + "/delete_specialities";

export const GET_ACCREDITATIONS_API = ADMIN_PREFIX + "/accreditation_list";
export const UPDATE_ACCREDITATIONS_API = ADMIN_PREFIX + "/edit_accreditation";
export const ADD_ACCREDITATIONS_API = ADMIN_PREFIX + "/add_accreditation";
export const DELETE_ACCREDITATIONS_API = ADMIN_PREFIX + "/delete_accreditation";

export const CURRENCY_LIST_API = ADMIN_PREFIX + "/currency_list"
export const UPDATE_CURRENCY_API = ADMIN_PREFIX + "/edit_currency";
export const ADD_CURRENCY_API = ADMIN_PREFIX + "/add_currency";
export const DELETE_CURRENCY_API = ADMIN_PREFIX + "/delete_currency";
